<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
          title="Custom Web & Mobile UX/UI Design"
          startingPrice="$7,999"
          :bullets="[
            'Responsive, accessible designs for web and mobile platforms',
            'A tailored design system/style guide to ensure consistency',
            'Wireframes and high-fidelity mockups for smooth developer handoff',
            'Accessibility review aligned with WCAG AA standards',
            'A design process that keeps you focused on outcomes, not resource management',
          ]"
          :overview="overview"
          cta-route="/schedule-a-meeting"
        />
        <MobileServicePackagesList />
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'CustomWebMobileUxUiDesign',
  components: { ServicePackagesSidebar, ServicePackageContent, MobileServicePackagesList },
  data() {
    return {
      overview:
        'We design user-centered, modern, and accessible interfaces that bring your digital product to life. Our process combines intuitive UX with clean UI to deliver a ready-to-implement design system that enhances engagement and aligns with your brand.',
    };
  },
};
</script>

<style scoped>
.service-section {
  padding: 2rem 1rem;
  background: #f9fafb;
}

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col {
  min-width: 0;
}

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
